// runtime-teams.js — tiny team lookup helpers shared by the match flow, intro
// sequence and overlay renderers. Split from runtime-core.js.
import { get } from 'svelte/store';
import { activeMatch } from './svelte/store.js';
import { getMeta } from './store.js';

export function teamObj(letter) {
  if (!get(activeMatch)) return null;
  return letter === "A" ? get(activeMatch).teamA : get(activeMatch).teamB;
}

export function battingTeamLetter(inn) { return inn.battingTeam; }

export function bowlingTeamLetter(inn) { return inn.battingTeam === "A" ? "B" : "A"; }

export function teamColor(name) { return getMeta(name).color; }

export function teamLogo(name) { return getMeta(name).logo; }

